module.exports = __webpack_public_path__ + "img/990recMac2.c0119e91.png";